import { render, staticRenderFns } from "./tabPage.vue?vue&type=template&id=0d25ebaa&scoped=true"
import script from "./tabPage.vue?vue&type=script&lang=js"
export * from "./tabPage.vue?vue&type=script&lang=js"
import style0 from "./tabPage.vue?vue&type=style&index=0&id=0d25ebaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d25ebaa",
  null
  
)

export default component.exports